// extracted by mini-css-extract-plugin
export default {"scroll":"Content_scroll__IjakO","content":"Content_content__Nip01","fade":"Content_fade__PbIIk"};